export default __webpack_public_path__ + "static/media/packaging_hero.8f43a167.jpg";